(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["accordion"] && !Shopify.designMode) return;
  try {
    document.addEventListener("DOMContentLoaded", function() {
    // Detect current page
    const isFaqPage = window.location.pathname.includes('/pages/faq');

    const accordions = document.querySelectorAll('.accordion');
    const limit = 4;

    accordions.forEach(accordion => {
      const wrapper = accordion.querySelector('.accordion-wrapper');
      const toggleBtn = accordion.querySelector('.accordion-toggle-btn');

      if (!wrapper || !toggleBtn) return;

      const items = Array.from(wrapper.children);

      // 🧩 Skip limiting logic if on FAQ page
      if (isFaqPage) {
        toggleBtn.style.display = "none"; // hide the button
        items.forEach(item => (item.style.display = "")); // show all
        return;
      }

      // Normal limit logic for other pages
      if (items.length > limit) {
        items.slice(limit).forEach(item => {
          item.style.display = "none";
        });

        toggleBtn.addEventListener("click", function() {
          const expanded = toggleBtn.classList.toggle('expanded');

          if (expanded) {
            items.slice(limit).forEach(item => {
              item.style.display = "";
            });
            toggleBtn.textContent = "Show Less";
          } else {
            items.slice(limit).forEach(item => {
              item.style.display = "none";
            });
            toggleBtn.textContent = "Show More";
          }
        });
      } else {
        toggleBtn.style.display = "none";
      }
    });
  });
  } catch(e) { console.error(e); }
})();

})();
